// src/features/audit/components/AuditActorCard.tsx
import { Card } from '../../../app/components/foundation';
import type { AuditActor } from '../data/audit.mock';

export interface AuditActorCardProps {
  actor: AuditActor | undefined;
}

/**
 * Workspace card: who performed this audit event — name, role, and
 * tenant scope. `actor` comes from useAuditWorkspaceMock. Same
 * field-list markup as security/components/SecurityPolicyCard.tsx.
 */
export function AuditActorCard({ actor }: AuditActorCardProps) {
  return (
    <Card className="vania-audit-workspace-card">
      <h2 className="vania-audit-workspace-card-title">کاربر انجام‌دهنده</h2>

      {!actor ? (
        <p className="vania-audit-workspace-empty">اطلاعاتی از کاربر انجام‌دهنده ثبت نشده است.</p>
      ) : (
        <dl className="vania-audit-workspace-fieldlist">
          <div>
            <dt>نام</dt>
            <dd>{actor.name}</dd>
          </div>
          <div>
            <dt>نقش</dt>
            <dd>{actor.role}</dd>
          </div>
          <div>
            <dt>تننت</dt>
            <dd>{actor.tenant}</dd>
          </div>
        </dl>
      )}
    </Card>
  );
}
